import React from 'react'

import { withAuth } from '../auth/withAuth';
import ChatTopicSelection from '../shared/Chat/ChatTopicSelection';

function PracticeQuestionTopicSelection() {
  return <ChatTopicSelection title="Practice Questions" navigationPath="practice-questions" />;
}
const PracticeQuestionTopicSelectionWithAuth = withAuth(PracticeQuestionTopicSelection);
export default PracticeQuestionTopicSelectionWithAuth;